@if (scrollTopVisible) {
<a class="scroll-top" [class.show-mobile-bottom-bar]="showMobileBottomBar" (click)="scrollTop()">
  <mat-icon>expand_less</mat-icon>
</a>
}
